import { render, staticRenderFns } from "./AgreementModal.vue?vue&type=template&id=8f5ff9e6&scoped=true"
import script from "./AgreementModal.vue?vue&type=script&lang=js"
export * from "./AgreementModal.vue?vue&type=script&lang=js"
import style0 from "./AgreementModal.vue?vue&type=style&index=0&id=8f5ff9e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5ff9e6",
  null
  
)

export default component.exports